import { ModalDeleteConfirm } from "App/Component/ui";
import { defaultToastSuccess, defaultToastError } from "App/utils/helpers";
import React, { useState } from "react";

export default function useModalDelete({
	setNewData,
	handleClickYes,
	setChildren,
}) {
	const [dataID, setDataID] = useState(null);
	const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);

	function handleClickDelete(id) {
		setDataID(id);
		setShowModalDeleteConfirm(!showModalDeleteConfirm);
	}

	async function deleteList() {
		const response = await handleClickYes(dataID);

		console.log("🚀 ~ deleteList ~ response:", response);

		if (response.state) {
      if(setChildren){
        setChildren([]);
      }
			defaultToastSuccess(response.message);
			await setNewData();
		} else {
			defaultToastError(response.message);
		}

		setShowModalDeleteConfirm(false);
	}

	const ModalDelete = () => {
		return (
			<>
				{showModalDeleteConfirm && (
					<ModalDeleteConfirm
						confirmHandle={() => deleteList()}
						setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
					/>
				)}
			</>
		);
	};

	return {
		ModalDelete,
		handleClickDelete,
	};
}
